/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, IlluminateUser } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    IlluminateUserFromJSON,
    IlluminateUserToJSON,
} from "../models/index";

export interface AcceptSignupCodeRequest {
    code: string;
}

export interface CheckSignupCodeRequest {
    code: string;
    email: string;
}

/**
 *
 */
export class MyAccountHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Accept a signup code. Call this *before* calling GetMyAccountInfo or any other endpoint for the first time.
     */
    async acceptSignupCodeRaw(
        requestParameters: AcceptSignupCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["code"] == null) {
            throw new runtime.RequiredError(
                "code",
                'Required parameter "code" was null or undefined when calling acceptSignupCode().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["code"] != null) {
            queryParameters["code"] = requestParameters["code"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/myaccount/accept-signup-code`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Accept a signup code. Call this *before* calling GetMyAccountInfo or any other endpoint for the first time.
     */
    async acceptSignupCode(
        requestParameters: AcceptSignupCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.acceptSignupCodeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Accept the terms and conditions of the web, located at https://jetcharge.com.au/end-use-terms/
     */
    async acceptTermsAndConditionsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/myaccount/accept-terms-conditions`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Accept the terms and conditions of the web, located at https://jetcharge.com.au/end-use-terms/
     */
    async acceptTermsAndConditions(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.acceptTermsAndConditionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Check if the signup code is valid
     */
    async checkSignupCodeRaw(
        requestParameters: CheckSignupCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["code"] == null) {
            throw new runtime.RequiredError(
                "code",
                'Required parameter "code" was null or undefined when calling checkSignupCode().',
            );
        }

        if (requestParameters["email"] == null) {
            throw new runtime.RequiredError(
                "email",
                'Required parameter "email" was null or undefined when calling checkSignupCode().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["code"] != null) {
            queryParameters["code"] = requestParameters["code"];
        }

        if (requestParameters["email"] != null) {
            queryParameters["email"] = requestParameters["email"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/myaccount/check-signup-code`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Check if the signup code is valid
     */
    async checkSignupCode(
        requestParameters: CheckSignupCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.checkSignupCodeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get details of the currently logged-in user
     */
    async getMyAccountInfoRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<IlluminateUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/myaccount/info`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            IlluminateUserFromJSON(jsonValue),
        );
    }

    /**
     * Get details of the currently logged-in user
     */
    async getMyAccountInfo(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<IlluminateUser> {
        const response = await this.getMyAccountInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Log out the current user
     */
    async logOutRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/myaccount/logout`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Log out the current user
     */
    async logOut(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.logOutRaw(initOverrides);
        return await response.value();
    }
}
